import { render } from "./EnBetaBadge.vue?vue&type=template&id=0bc35f8c&ts=true"
import script from "./EnBetaBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnBetaBadge.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/badge/EnBetaBadge/EnBetaBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bc35f8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bc35f8c', __exports__)) {
    api.reload('0bc35f8c', __exports__)
  }
  
  module.hot.accept("./EnBetaBadge.vue?vue&type=template&id=0bc35f8c&ts=true", () => {
    api.rerender('0bc35f8c', render)
  })

}


export default __exports__